/*
 * @FilePath     : /es-template/src/plugins/request.js
 * @Author       : LiYang
 * @Date         : 2021-08-24 15:42:40
 * @LastEditTime: 2023-08-25 03:29:37
 * @LastEditors: liuziwei
 * @Description  : 请求拦截器实现url代理、res、req等处理
 */
import { XFetch } from '@mpxjs/fetch'
import config from '@/config/interceptors/index'
import raven from '@/common/raven-init/init'
import { closeMask } from '@/config/usex'

const xfetch = new XFetch()

async function createRequest(config) {
  const datas = config.method === 'get' ? config.params : config.data
  /**
   * raven traceRequest 返回一个 trackResponse 函数
   * 在 http 响应结果以后，调用下这个函数即可真正发送请求
   */
  let trackResponse = raven.trackRequest(config.url, datas)
  return xfetch
    .fetch(config)
    .then(res => {
      const { code, message, data = {} } = res || {}
      const traceId =
        data?.traceId ||
        data?.trace_id ||
        data?.apollo_trace ||
        data?.traceid ||
        data?.trace
      const resData = {
        /**
         * 如果响应结果太大，我们可以对响应结果做一些过滤
         * 以后查询的时候使用 traceId 是查询用户完整响应数据
         */
        code: code,
        message: message
      }
      /**
       * 标记 request 已响应
       * 上报接口响应的成功状态，以及 traceId，以及接口响应
       * @see http://book.intra.xiaojukeji.com/raven/api/objects.html#irequestdonehandler
       * @param success 请求成功或失败
       * @param traceId 如果传入 traceId，则会和把脉等服务端 trace 追踪服务打通
       * @param response 响应结果，谨慎选择！如果响应结果比较大的话建议对内容做下过滤（因为网络请求/性能等），完整信息可以通过 traceId 去跟进响应结果
       */
      trackResponse?.(true, traceId, resData)
      return res
    })
    .catch(err => {
      console.error(err)
      trackResponse?.(false, '', err)
    })
}

;['get', 'post', 'put', 'delete'].forEach(key => {
  createRequest[key] = function (url, config) {
    return createRequest({
      ...config,
      url,
      method: key.toLocaleUpperCase()
    })
  }
})

function domain(option) {
  const { transformRequest, transformResponse } = option

  xfetch.interceptors.request.use(req =>
    typeof transformRequest === 'function' ? transformRequest(req) : req
  )

  xfetch.interceptors.response.use(
    res =>
      typeof transformResponse === 'function' ? transformResponse(res) : res,
    () => {
      closeMask()
      return {
        success: false
      };
    }
  )
}

function fetchProxy(proxy, options, MPX) {
  if (fetchProxy.installed) {
    return
  }
  const defineOption = {
    writable: false,
    configurable: false,
    enumerable: true
  }

  fetchProxy.installed = true
  domain(options)

  proxy.$fetch = createRequest
  proxy.$http = createRequest

  Object.defineProperties(proxy.prototype, {
    $fetch: {
      ...defineOption,
      value: createRequest
    },
    $http: {
      ...defineOption,
      value: createRequest
    }
  })
}

export default app => {
  app.use(fetchProxy, config)
}
